import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeUnmount, nextTick, } from 'vue'
import { MessageBox, Message } from 'element-ui'
import _ from 'lodash'
import { JtTableProps } from '@/components/JtTable/types'
import { IMtList } from '@/api/mt/type'
import { taskStateMap, languageMap} from './type'
import { deleteTaskAPI, exportTaskAPI, getProgressAPI, getResultList} from '@/api/mt/index'
import { downloadFile } from '@/utils'
import Result from './Result.vue'
import { PageReqSchema } from '@/types/axios/public-json-structure'
import { convertToBrowserTimezone } from '@/utils'
import { StorageDaysModule } from '@/store/modules/storage-days'



export default /*#__PURE__*/_defineComponent({
  __name: 'MtList',
  setup(__props) {

const jtTableRef = ref()
const jtConfig:JtTableProps.ColumnConfig<keyof IMtList.IMtListRes | 'handle', IMtList.IMtListRes>[] = [
  {
    label: '名称',
    prop: 'name',
    isSlot: true,
    elColProps: {
      align: 'left',
      headerAlign: 'left'
    }
  },
  {
    label: '创建时间',
    prop: 'createDt',
    elColProps: {
      align: 'left',
      headerAlign: 'left',
      formatter(row) {
        if (row.createDt) {
          return convertToBrowserTimezone(row.createDt)
        } else {
          return '-'
        }
      }
    }
  },
  {
    label: '翻译方向',
    prop: 'language',
    elColProps: {
      align: 'left',
      headerAlign: 'left'
    }
  },
  {
    label: '状态',
    prop: 'status',
    isSlot: true,
    elColProps: {
      align: 'left',
      headerAlign: 'left'
    }
  },
  {
    label: '操作',
    prop: 'handle',
    isSlot: true,
    elColProps: {
      align: 'left',
      headerAlign: 'left'
    }
  }
]
const tableData = ref<IMtList.IMtListRes[]>([])
async function tableApi(page: PageReqSchema) {
  // 清空勾选
  nextTick(() => {
    selectData.value = []
  })
  try {
    let res = await getResultList(page)
    tableData.value = res.data
    loopGetProgress(tableData.value)
    return res
  } catch (error) {
    error
  }
}
// 轮询查询进度
function loopGetProgress(data:IMtList.IMtListRes[]) {
  let idArray: string[] = []
  timers && clearInterval(timers)
  timers = window.setInterval(() => {
    idArray = []
    const filterArray = data.filter((t:IMtList.IMtListRes) => t.status != IMtList.ETaskState.Done && t.status != IMtList.ETaskState.Fail)
    idArray.push(...filterArray.map((t: IMtList.IMtListRes) => t.id))
    if (!idArray.length) {
      clearInterval(timers)
      timers = undefined
    } else {
      getProgress(idArray)
      // 更新识别进度及状态
      jtTableRef.value?.updateTableData(tableData.value)
    }
  }, 2000)
}

// 根据ids获取当前页待识别和识别中item的最新状态与进度
async function getProgress (ids: string[]) {
  if (!ids.length) return
  const { data } = await getProgressAPI({ id: ids.join(',') })
  tableData.value?.forEach(t => {
    data.some((f) => {
      if (f.id === t.id) {
        t.progress = Number(f.progress)
        t.status = f.status
      }
    })
  })
}
// 根据状态排序
function sortByState (data: IMtList.IMtListRes[]) {
  const order: IMtList.ETaskState[] = [
    IMtList.ETaskState.Working,
    IMtList.ETaskState.Fail,
    IMtList.ETaskState.Loading,
    IMtList.ETaskState.Init,
    IMtList.ETaskState.Done
  ]
  const target: IMtList.IMtListRes[] = []
  order.forEach((status) => {
    const sortArray = data.filter(t => t.status === status).sort((a, b) => {
      return handleTimeSort(b.createDt, a.createDt)
    })
    if (sortArray.length) {
      target.push(...sortArray)
    }
  })
  return target
}
function handleTimeSort (t1: string, t2: string) {
  return Number(new Date(t1).getTime()) - Number(new Date(t2).getTime())
}
onBeforeUnmount(() => {
  clearInterval(timers)
})

const selectData = ref<IMtList.IMtListRes[]>([])
function selectChange (data: IMtList.IMtListRes[]) {
  selectData.value = data
}
const checkboxConfig = {
  // 仅完成状态的条目可勾选
  selectable: (row: IMtList.IMtListRes) => {
    return row.status === IMtList.ETaskState.Done
  }
}

function deleteTask (t: IMtList.IMtListRes[]) {
  MessageBox.confirm('删除后不可恢复，请确认', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    // 删除接口
    await deleteTaskAPI(t.map(f => f.id))
      .then(() => {
        Message.success('删除成功!')
        jtTableRef.value?.refreshCurrent()
      }).catch((error) => {
        console.log(error)
        Message.error('删除失败!')
      })
  }).catch(() => {})
}

function getStateTitle (status: IMtList.ETaskState) {
  return taskStateMap[status]
}

let timers: number | undefined
// 导出
function exportFile (data: IMtList.IMtListRes[]) {
  exportTaskAPI({ id: data.map(t => t.id).join(',') })
    .then(res => {
      downloadFile(res)
    })
}
const isShowRes = ref(false)
const fileId = ref('')
function handleBackTo (id?: string,) {
  if (id) {
    // 跳转到翻译结果
    fileId.value = id
    isShowRes.value = true
  } else {
    // 跳转到文件翻译
    isShowRes.value = false
  }
}
function nameClick (item: IMtList.IMtListRes) {
  if (item.status != IMtList.ETaskState.Done) return
  handleBackTo(item.id)
}


return { __sfc: true,jtTableRef, jtConfig, tableData, tableApi, loopGetProgress, getProgress, sortByState, handleTimeSort, selectData, selectChange, checkboxConfig, deleteTask, getStateTitle, timers, exportFile, isShowRes, fileId, handleBackTo, nameClick, IMtList, Result, StorageDaysModule }
}

})